<template>
    <div class="l-body">
        <LBackgruond>
            <template v-slot:mainName> 战报上传 </template>
            <template v-slot:mainContent>
                <div class="l-upload-body">
                    <div class="l-upload-main">
                        <LUploadLevel :options="uploadTypeData" @getTypeData="handleTypeData"></LUploadLevel>
                        <div class="l-upload-main-img">
                            <div class="l-upload-main-img-box">
                                <div class="l-upload-img-item" v-for="item in stageData.files" @click="handlePreview(item)"
                                    :key="item.url">
                                    <img v-if="fileType === 'img'" :src="item.url" alt="" />
                                    <video v-else :src="item.url">您的浏览器不支持 video 标签。</video>
                                    <div @click.stop="handleDelUrl(item.url)" class="del">删除</div>
                                </div>
                                <template v-if="isAPP">
                                    <div v-if="isAppOk" class="l-upload-img-add" @click="handleAdd()">+</div>
                                </template>
                                <template v-else>
                                    <div class="l-upload-img-file">
                                        <button @click="handleFile()">+</button>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="l-upload-button">
                        <div class="l-upload-main-img-tips">
                            *注：仅支持上传{{
                                fileType === "img" ? imageType.toString() : videoType.toString()
                            }}格式的文件
                        </div>
                        <div class="l-upload-submit">
                            <img @click="handnleReset" src="./images/reset.png" />
                            <img @click="handleSubmit" src="./images/submit.png" />
                        </div>
                    </div>
                </div>
            </template>
        </LBackgruond>
        <div v-if="isPreview" class="preview">
            <swiper ref="mySwiper" :options="swiperOption" class="preview-swiper">
                <swiper-slide v-for="(item, index) in stageData.files" :key="index" class="preview-img">
                    <img v-if="item.type === 'img'" :src="item.url" alt="" />
                    <video v-else :src="item.url" controls controlslist="nodownload">您的浏览器不支持 video 标签。</video>
                </swiper-slide>
            </swiper>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
            <div class="preview-colse" @click="isPreview = false">关闭</div>
        </div>
    </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
// import LButtonCommon from '@/views/learn-new/components/l-button-common'
import ImageCompressor from 'js-image-compressor'
import LBackgruond from "./../components/l-background"
import LUploadLevel from "./components/l-upload-level"
import { upload, hasNativeMethod } from '@/utils/bridge'
import { isAPP } from "@/utils/util"
import HTTP from '@/utils/http'
import TaskModel from './../models/task'
// import CourseModel from './../models/course'
const http = new HTTP()
const taskModel = new TaskModel()
// const courseModel = new CourseModel()
export default {
    name: "workUpload",
    components: {
        swiper, swiperSlide,
        // LButtonCommon,
        LBackgruond,
        LUploadLevel,
    },
    data() {
        return {
            uploadTypeData: {},
            isAPP: isAPP,
            imageType: ["jpg", "png", "jpeg"],
            videoType: ["mp4", "mov"],
            fileType: "img",
            stageData: {
                type: "",
                stage: "",
                level: "",
                story: "",
                uploadTime: new Date().getTime(),
                files: [],
            },
            userId: "",
            isAppOk: true,
            detailData: {},
            isPreview: false,
            preview: {
                type: '',
                url: ''
            },
            swiperOption: {
                autoplay: false,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            },
        }
    },
    mounted() {
        // this.uploadTypeData = JSON.parse(sessionStorage.getItem('wordUploadData'))
        // this.fileType = this.uploadTypeData.uploadType;
        this.handleGetData()
        this.handleIsMethod()
        this.handleGetUser()
    },
    methods: {
        handleGetData() {
            this.uploadTypeData = JSON.parse(sessionStorage.getItem('wordUploadData') || "")
            this.fileType = this.uploadTypeData.uploadType
            if (this.uploadTypeData && this.uploadTypeData.battleStatus === 2) {
                this.stageData.files = this.uploadTypeData.battleInfo.userRecord.files
            }
        },
        handleGetUser() {
            let user = localStorage.getItem(window.$USERKEY || "USER")
                ? JSON.parse(localStorage.getItem(window.$USERKEY || "USER"))
                : {
                    userId: ''
                }
            this.userId = user.userId
        },
        getVersion(str, key) {
            let version = ""
            let index = str.indexOf(key) + key.length
            if (index < key.length) {
                return version
            }
            let i = 0
            while (
                str.slice(index + i, index + i + 1) === "." ||
                !isNaN(parseInt(str.slice(index + i, index + i + 1)))
            ) {
                version = version + "" + str.slice(index + i, index + i + 1)
                i++
                if (i > 10) {
                    break
                }
            }
            return version
        },
        compareVersion(version1, version2) {
            const arr1 = version1.split('.').map(e => e * 1)
            const arr2 = version2.split('.').map(e => e * 1)
            const length = Math.max(arr1.length, arr2.length)
            for (let i = 0;i < length;i++) {
                if ((arr1[i] || 0) > (arr2[i] || 0)) {
                    return 1
                }
                if ((arr1[i] || 0) < (arr2[i] || 0)) {
                    return -1
                }
            }
            return 0
        },
        // 判断是否存在方法
        handleIsMethod() {
            if (isAPP) {
                let app = navigator.userAgent.toLowerCase()
                let version = this.getVersion(app, "lilytribe/")
                let isNewVersions = this.compareVersion(version, "2.2.0")
                if (isNewVersions < 0) {
                    // this.$lPrompt({
                    //     message: "请更新最新版本app，使用此功能",
                    //     successTxt: "确定",
                    //     successFn: () => {
                    //         this.$router.back()
                    //     }
                    // })
                    // return
                }
                let options = {
                    methodName: "upload",
                }
                try {
                    hasNativeMethod(options, (res) => {
                        let data = JSON.parse(res)
                        if (data.status) {
                            if (data.data === false) {
                                this.$lPrompt({
                                    message: "请更新最新版本app，使用此功能",
                                    successTxt: "确定",
                                    successFn: () => {
                                        this.$router.back()
                                    },
                                })
                            }
                            this.isAppOk = data.data
                            return
                        } else {
                            this.$lPrompt({
                                message: "、请求错误，请刷新页面或更新最新版本app",
                                successTxt: "确定",
                                successFn: () => {
                                    this.$router.back()
                                },
                            })
                        }
                    })
                } catch (err) {
                    this.$lPrompt({
                        message: "请更新最新版本app，使用此功能",
                        successTxt: "确定",
                        successFn: () => {
                            this.$router.back()
                        }
                    })
                }
            }
        },
        // app上传部分
        handleAdd() {
            if (isAPP) {
                // 上传限制
                let listLength = 20
                // 文件类型
                let dataType = this.imageType
                // 上传大小
                let size = 1024 * 1024 * 10
                // 每次上传张数限制
                let max = 1

                if (this.fileType === "img") {
                    dataType = this.imageType
                    listLength = 20
                    size = 1024 * 1024 * 10
                    max = 10
                } else if (this.fileType === "video") {
                    dataType = this.videoType
                    size = 1024 * 1024 * 50
                    listLength = 5
                    max = 1
                } else {
                    dataType = this.imageType
                    listLength = 20
                    size = 1024 * 1024 * 10
                    max = 10
                }
                if (this.stageData.files.length >= listLength) {
                    this.$lPrompt({
                        message: `上传文件数量不能超过${listLength}个`,
                        successTxt: "确定",
                    })
                    return false
                }
                let options = {
                    rules: [
                        {
                            type: this.fileType,
                            size: size,
                            ext: dataType,
                        },
                    ],
                    "app": "task",
                    "max": max
                }
                upload(options, data => {
                    let res = JSON.parse(data)
                    if (res.status) {
                        if (typeof res.data === "string") {
                            let options = {
                                type: this.fileType,
                                url: res.data,
                            }
                            this.stageData.files.push(options)
                        } else if (Array.isArray(res.data)) {
                            res.data.forEach((item) => {
                                if (this.stageData.files.length < listLength) {
                                    let listItem = {
                                        type: this.fileType,
                                        url: item.url,
                                    }
                                    this.stageData.files.push(listItem)
                                }

                            })
                        } else {
                            console.log('data is neither a string nor an array')
                        }

                        // than.stageData.url.push(res.data)
                    } else {
                        // this.$lPrompt({
                        //     message: "请更新最新版本app，使用此功能",
                        //     successTxt: "确定",
                        //     successFn: () => {
                        //         this.$router.back()
                        //     },
                        // });
                    }
                })
            }
        },
        // 网页上传部分
        handleFile() {
            // 上传限制
            let listLength = 20
            // 文件类型
            let dataType = this.imageType
            // 上传地址
            let dataUrl = "/imgup/img/upload/neverexpire"
            // 上传大小
            let size = 1024 * 1024 * 10
            if (this.fileType === "img") {
                dataType = this.imageType
                listLength = 20
                size = 1024 * 1024 * 10
                dataUrl = "/imgup/img/upload/neverexpire"
            } else if (this.fileType === "video") {
                dataType = this.videoType
                size = 1024 * 1024 * 50
                dataUrl = "/imgup/misc/upload/neverexpire"
                listLength = 5
            } else {
                dataType = this.imageType
                listLength = 20
                size = 1024 * 1024 * 10
                dataUrl = "/imgup/img/upload/neverexpire"
            }
            if (this.stageData.files.length >= listLength) {
                this.$lPrompt({
                    message: `上传文件数量不能超过${listLength}个`,
                    successTxt: "确定",
                })
                return false
            }
            const fileType = dataType
            const inputFile = document.createElement("input")
            inputFile.type = "file"
            inputFile.style.display = "none"
            document.body.appendChild(inputFile)
            inputFile.click()
            inputFile.addEventListener("change", () => {
                const file = inputFile.files[0]
                // 文件格式判断
                let testData = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase()
                if (!fileType.includes(testData)) {
                    this.$lPrompt({
                        message: `上传文件格式只能是${fileType.toString()}`,
                        successTxt: "确定",
                        successFn: function () {
                            document.body.removeChild(inputFile)
                        },
                    })
                    return false
                }
                new ImageCompressor({
                    file: file,
                    quality: 0.8,
                    success: (result) => {
                        // 文件大小判断
                        if (result.size > size) {
                            this.$lPrompt({
                                message: `上传文件大小应不超过${size / 1024 / 1024}M`,
                                successTxt: "确定",
                                successFn: function () {
                                    document.body.removeChild(inputFile)
                                },
                            })
                            return false
                        }
                        let name = `${this.userId}_${new Date().getTime()}.${testData}`
                        let newFile = new File([result], name, { type: result.type })
                        const formData = new FormData()
                        formData.append("file", newFile)
                        http.post({
                            url: dataUrl,
                            headers: {
                                "Content-Type": "multipart/form-data",
                                app: "task",
                            },
                            data: formData,
                        }).then((res) => {
                            if (res.status === 0) {
                                let data = {
                                    type: this.fileType,
                                    url: res.data[0].url,
                                }
                                this.stageData.files.push(data)
                            }
                        }).finally(() => {
                            document.body.removeChild(inputFile)
                        })
                    },
                    error(e) {
                        console.error('压缩图片失败', e.message)
                    },
                })
            })
        },
        // 获取左侧参数
        handleTypeData(data) {
            this.stageData = { ...this.stageData, ...data }
        },
        // 提交数据
        handleSubmit() {
            if (this.stageData.files <= 0) {
                this.$lPrompt({
                    message: `上传文件不能为空`,
                    successTxt: "确定",
                })
                return
            }
            this.$lPrompt({
                message: `请认真检查上传的内容，不要传错哦`,
                successTxt: "确定提交",
                cancelTxt: "再想想",
                showCancel: true,
                successFn: () => {
                    this.stageData.uploadTime = new Date().getTime()
                    let options = {
                        taskId: this.uploadTypeData.taskId,
                        data: this.stageData,
                    }
                    taskModel.postElementUpload(options).then((res) => {
                        if (res.status === 0) {
                            if (res.data) {
                                this.$lPrompt({
                                    message: `上传战报成功`,
                                    successTxt: "确定",
                                    successFn: () => {
                                        this.$router.back()
                                    },
                                })
                            }
                        }
                    })
                },
                cancelFn: () => { },
            })
        },
        handnleReset() {
            this.$lPrompt({
                message: `确定要删除已上传的内容，并重新上传吗？`,
                successTxt: "确定",
                cancelTxt: "取消",
                showCancel: true,
                successFn: () => {
                    this.stageData.files = []
                },
                cancelFn: () => { },
            })
        },
        handleDelUrl(value) {
            let indexOf = -1
            for (let i = 0;i <= this.stageData.files.length - 1;i++) {
                if (this.stageData.files[i].url === value) {
                    indexOf = i
                    break
                }
            }
            if (indexOf > -1) {
                this.stageData.files.splice(indexOf, 1)
            }
        },
        handlePreview(item) {
            this.preview = {}
            this.preview = item
            this.isPreview = true
        },
    },
}
</script>
<style lang="stylus" scoped>
@import "./css/upload.styl";

.swiper-button-prev {
    width: 60px;
    height: 60px;
    background: url('./images/prev-btn.png') center/100% no-repeat;
}
.swiper-button-next {
    width: 60px;
    height: 60px;
    background: url('./images/next-btn.png') center/100% no-repeat;
}
</style>
